import { jsxs as n, jsx as o, Fragment as d } from "react/jsx-runtime";
import { ActionButtons as f } from "../action-buttons/ActionButtons.component.js";
import { Button as i } from "../button/Button.component.js";
import { ButtonThemeEnum as u } from "../button/types.js";
import { Divider as h } from "../divider/Divider.component.js";
import { useCallback as x } from "react";
const D = ({
  close: c,
  onSave: r,
  copies: e,
  children: p,
  className: a,
  isLoading: m,
  isDisabled: l
}) => {
  const s = x(
    async (t) => {
      t.preventDefault(), t.stopPropagation(), r();
    },
    [r]
  );
  return /* @__PURE__ */ n("form", { onSubmit: s, className: a, children: [
    p,
    /* @__PURE__ */ o(h, {}),
    /* @__PURE__ */ o(
      f,
      {
        cancelButtonText: e.cancel,
        submitButtonText: e.submit,
        isLoading: m,
        children: ({ submitButtonProps: t, cancelButtonProps: b }) => /* @__PURE__ */ n(d, { children: [
          /* @__PURE__ */ o(
            i,
            {
              ...b,
              theme: u.naked,
              type: "button",
              onClick: c
            }
          ),
          /* @__PURE__ */ o(
            i,
            {
              ...t,
              disabled: m || l,
              theme: u.primary,
              type: "submit"
            }
          )
        ] })
      }
    )
  ] });
};
export {
  D as EditorMenuContent
};
